export default __webpack_public_path__ + "static/media/edit-goal.c0c9838b.svg";